import $ from 'jquery';
import { has } from 'lodash';
import { Formatter } from '@dealersites/dealersite-js-core';
import { dspFinance, dspLease } from './components/payment-calc/dsp-calculator.js';
import { __ } from '@wordpress/i18n';

const dsp = (global.dsp = global.dsp || {});

/**
 *
 * @param element
 */
export function scrollToTopOfElement(element, duration = 1000, offset = 0) {
  $('html, body').animate(
    {
      scrollTop: element.offset().top - offset,
    },
    duration 
  );
}

/**
 *
 * @param str // representing the string time i.e. "8:00"
 * @param period // representing the period of day i.e. "AM" or "PM"
 */

export function convertStrToMilitaryTime(str, period) {
  const strings = str.split(':');
  const hour = parseInt(strings[0]);
  const minutes = parseInt(strings[1]) / 60;
  return period == 'AM' ? hour + minutes : hour + 12 + minutes;
}

export function trimHTMLtoWordCount(HTML, wordcount) {
  // removes all html tags - converts to text
  HTML = HTML.replace(/<br\s\/>/g, ' @break ')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();

  // trims out any words over the count
  HTML = HTML.split(' ')
    .slice(0, wordcount)
    .join(' ')
    .replace(/&amp;/g, '&')
    .replace(/&nbsp;/g, ' ')
    .replace(/@break/g, '<br>');

  return HTML;
}

export function trimHTMLtoCharCount(HTML, charcount) {
  // removes all html tags - converts to text
  HTML = HTML.replace(/<br\s\/>/g, ' @break ')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();

  // trims out any words over the count
  HTML = HTML.substring(0, charcount);

  return HTML;
}

export function isOdd(num) {
  return num % 2;
}

export function replaceUrlParam(url, paramName, paramValue) {
  if (paramValue == null) {
    paramValue = '';
  }
  var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, '$1' + paramValue + '$2');
  }
  url = url.replace(/[?#]$/, '');
  return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
}

export async function getDOMVehicleCard(item, disclaimer = '', features = [], language = 'en') {
  const vehiclePrice = item.pricing
    ? Formatter.price(item.pricing.final_price, 0)
    : __('Please Call', 'ford-oem-theme');

  const vehicleLink = item.url + (language == 'fr' ? '?lang=fr' : '');

  const imgUrl = item.photos
    ? item.photos.md
    : '/content/mu-plugins/dealersite-inventory/assets/img/nophoto.svg';

  const payments = {
    finance: false,
    lease: false,
  };

  if (features.length) {
    if (features.includes('2') || features.includes('3')) {
      // Replace incentives with NASAPI values, if available.
      if (item.is_new) {
        if (dsp.incentives && item.load_nasapi) {
          const nasapiIncentives = await dsp.incentives.fetch(item.id);
          if (has(nasapiIncentives, 'finance.value') && features.includes('2')) {
            if (nasapiIncentives.finance.value.length > 0) {
              item.pricing.finance.rules = nasapiIncentives.finance.value;
            }
          }
          if (has(nasapiIncentives, 'lease.value') && features.includes('3')) {
            let nasapiLease = nasapiIncentives.lease.value.reduce((incentives, incentive) => {
              if (incentive.residual_value) {
                let residual = incentive.residual_value;
                incentive.residual = residual;
                incentive.residual_value = item.pricing.regular_price * (residual / 100);
                incentive.incentive_price = item.pricing.lease.adjusted_price;
                incentives.push(incentive);
              }
              return incentives;
            }, []);
            if (nasapiLease.length > 0) {
              item.pricing.lease.rules = nasapiLease;
            }
          }
        }
      }

      // Calculate financing.
      if (features.includes('2')) {
        payments.finance = dspFinance(item);
      }

      // Calculate leasing.
      if (features.includes('3')) {
        payments.lease = dspLease(item);
      }
    }
  }

  return `<div class="featured-card featured-card-async opacity-0">

      <a href="${vehicleLink}" class="group featured-card-hitbox">

      <div class="featured-card-overlay group-hover:w-full opacity-0 group-hover:opacity-100">
        <div class="featured-overlay-content">

        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"/></svg>

        </div>
      </div>

      <img class="featured-image group-hover:border-[3px] group-hover:border-ford-2 opacity-0"
      src="${imgUrl}"
      alt="${item.name + ' ' + item.trim}"
      itemprop="image"/>

      <div class="featured-info">
        <div class="featured-title text-elipsis">
          <p class="main-title group-hover:text-ford-2">
            ${item.title}
          </p>
          <p class="under-title ">
            ${item.trim}
          </p>
        </div>

        ${features.length ? getSelectedFeatures(item, features, payments) : ''}

        <div class="featured-price">
          ${
            features.includes('1')
              ? `<div>
              ${
                item.regular_price > item.final_price
                  ? `<span class="block line-through font-brand font-normal text-slate-500 text-sm">
                      ${Formatter.price(item.regular_price, 0)}
                    </span>`
                  : ``
              }

              <div class="flex gap-1">
                <span class="price group-hover:text-ford-2" data-nasapi="">
                  ${vehiclePrice}
                </span>

                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="dsp-icon-md text-slate-500 group-hover:text-ford-black mt-1" fill="currentColor"><path d="M21.41 11.41l-8.83-8.83c-.37-.37-.88-.58-1.41-.58H4c-1.1 0-2 .9-2 2v7.17c0 .53.21 1.04.59 1.41l8.83 8.83c.78.78 2.05.78 2.83 0l7.17-7.17c.78-.78.78-2.04-.01-2.83zM12.83 20L4 11.17V4h7.17L20 12.83L12.83 20z"></path><circle cx="6.5" cy="6.5" r="1.5"></circle></svg>
              </div>
              <span class="disclaimer">
                ${item.pricing.cash.disclaimers.tax_disclaimer}
                ${item.pricing.cash.disclaimers.add_disclaimer}
              </span>
            </div>`
              : ''
          }

          <div>
            <button class="dsp-frd-btn group-hover:bg-ford-dark group-hover:border-ford-dark"> Learn More </button>
          </div>
        </div>
      </div>
    </a>
  </div>`;
}

function getSelectedFeatures(item, features, payments) {
  return `<div class="vehicle-card-info">

      ${
        features.includes('11') && item.carfax_account_number
          ? `<div class="hidden">
        <div class="carfax-badge" data-vin="${item.vin}" data-account-number="${item.carfax_account_number}">
          <img />
        </div>
      </div>`
          : ''
      }
    ${features.length > 1 ? getFeaturesGrid(item, features, payments) : ``}
  </div>`;
}

function getFeaturesGrid(item, features, payments) {
  return `<div class="vehicle-info-grid">
      ${
        features.includes('2')
          ? `<div class="vehicle-feature payment-feature">

          <div class="payment-feature-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="h-3.5 w-3.5" fill="currentColor"><path d="M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98a2.013 2.013 0 0 0-1.81-1.23c-.26 0-.53.04-.79.15L7.1 5.95a1.999 1.999 0 0 0-1.08 2.6l4.96 11.97a1.998 1.998 0 0 0 2.6 1.08l7.36-3.05a1.994 1.994 0 0 0 1.09-2.6zm-9.2 3.8L7.87 7.79l7.35-3.04h.01l4.95 11.95l-7.35 3.05z"></path><circle cx="11" cy="9" r="1"></circle><path d="M5.88 19.75c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"></path></svg>
          </div>

          <h4 class="vehicle-feature-title"> ${__('Finance From', 'ford-oem-theme')} </h4>
          <div class="vehicle-feature-info">
            <span class="payment">${
              payments.finance > 0
                ? Formatter.price(payments.finance, 0) + '/BIW'
                : `<div class="payment-link"> ${__('Contact Us', 'ford-oem-theme')} </div>`
            } </span>
          </div>
      </div>`
          : ''
      }

      ${
        features.includes('3')
          ? `<div class="vehicle-feature payment-feature">
            <div class="payment-feature-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="h-3.5 w-3.5" fill="currentColor"><path d="M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98a2.013 2.013 0 0 0-1.81-1.23c-.26 0-.53.04-.79.15L7.1 5.95a1.999 1.999 0 0 0-1.08 2.6l4.96 11.97a1.998 1.998 0 0 0 2.6 1.08l7.36-3.05a1.994 1.994 0 0 0 1.09-2.6zm-9.2 3.8L7.87 7.79l7.35-3.04h.01l4.95 11.95l-7.35 3.05z"></path><circle cx="11" cy="9" r="1"></circle><path d="M5.88 19.75c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"></path></svg>
            </div>

            <h4 class="vehicle-feature-title"> ${__('Lease From', 'ford-oem-theme')} </h4>
            <div class="vehicle-feature-info">
              <span class="payment">${
                payments.lease > 0
                  ? Formatter.price(payments.lease, 0) + '/BIW'
                  : `<div class="payment-link"> ${__('Contact Us', 'ford-oem-theme')} </div>`
              } </span>
            </div>
          </div>`
          : ''
      }

      ${
        features.includes('4')
          ? `<div class="vehicle-feature">
            <h4 class="vehicle-feature-title"> ${__('Mileage', 'ford-oem-theme')} </h4>
            <div class="vehicle-feature-info">
            ${item.odometer}
            </div>
          </div>`
          : ''
      }

      ${
        features.includes('5')
          ? `<div class="vehicle-feature">
            <h4 class="vehicle-feature-title"> ${__('Stock #', 'ford-oem-theme')} </h4>
            <div class="vehicle-feature-info">
              ${item.stock_num}
            </div>
          </div>`
          : ''
      }

      ${
        features.includes('6')
          ? `<div class="vehicle-feature">
            <h4 class="vehicle-feature-title"> ${__('VIN', 'ford-oem-theme')} </h4>
            <div class="vehicle-feature-info" style="direction: rtl !important;">
              ${item.vin}
            </div>
          </div>`
          : ''
      }

      ${
        features.includes('7')
          ? `<div class="vehicle-feature">
            <h4 class="vehicle-feature-title"> ${__('Transmission', 'ford-oem-theme')} </h4>
            <div class="vehicle-feature-info">
            ${item.transmission_type.name ?? __('Unsure', 'ford-oem-theme')}
            </div>
          </div>`
          : ''
      }

    ${
      features.includes('8')
        ? `<div class="vehicle-feature">
          <h4 class="vehicle-feature-title"> ${__('Drive Type', 'ford-oem-theme')} </h4>
          <div class="vehicle-feature-info">
            ${item.drive_type.name}
          </div>
        </div>`
        : ''
    }

    ${
      features.includes('9')
        ? `<div class="vehicle-feature">
          <h4 class="vehicle-feature-title"> ${__('Engine Type', 'ford-oem-theme')} </h4>
          <div class="vehicle-feature-info">
            ${item.engine_type}
          </div>
        </div>`
        : ''
    }

    ${
      features.includes('12')
        ? `<div class="vehicle-feature">
          <h4 class="vehicle-feature-title"> ${__('Displacement', 'ford-oem-theme')} </h4>
          <div class="vehicle-feature-info">
            ${item.displacement}
          </div>
        </div>`
        : ''
    }

    ${
      features.includes('10')
        ? `<div class="vehicle-feature">
          <h4 class="vehicle-feature-title"> ${__('Inventory Status', 'ford-oem-theme')} </h4>
          <div class="vehicle-feature-info">
            ${item.inventory_status}
          </div>
        </div>`
        : ''
    }
  </div>`;
}

export function capFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
